/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicItemType } from '../../models/public-item-type';

export interface ConnectorGetItemTypes$Params {
}

export function connectorGetItemTypes(http: HttpClient, rootUrl: string, params?: ConnectorGetItemTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicItemType>>> {
  const rb = new RequestBuilder(rootUrl, connectorGetItemTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PublicItemType>>;
    })
  );
}

connectorGetItemTypes.PATH = '/apollon-connector/enums/item-types';
